export const TALK_TO_SALES_PATH = "/talk-to-sales";
export const BOOKING_CONFIRMED_PATH = "/booking/confirmed";

export const GROUPS_PLAN = {
  key: "groups",
  name: "Groups",
  // badge: "Custom",
  description: "All in one AI platform for your clinic",
  priceLabel: "Custom",
  /** Pricing table column — avoid repeating “Custom” under the badge */
  columnPriceLabel: "—",
  ctaLabel: "Talk to sales",
  featuresHeader: "Includes everything in Elite plus:",
  features: [
    "Medical Assistant users",
    "Patient sharing",
    "Live clinic onboarding",
    "Single sign-on (SSO)",
    "Admin dashboards & custom configurations",
    "Dedicated account manager",
  ],
};

/** Enterprise-only rows shown in the pricing comparison table. */
export const GROUPS_COMPARISON_FEATURES = [
  { name: "Medical Assistant users", byKey: { groups: true } },
  { name: "Patient sharing", byKey: { groups: true } },
  { name: "Live clinic onboarding", byKey: { groups: true } },
  { name: "Single sign-on (SSO)", byKey: { groups: true } },
  {
    name: "Admin dashboards & custom configurations",
    byKey: { groups: true },
  },
  { name: "Dedicated account manager", byKey: { groups: true } },
];

export const BOOKING_REDIRECT_DELAY_MS = 3500;
